import React from 'react';
import './GettingStarted.css';

const GettingStarted = () => {
  const items = [
    {
      id: 'getting-started',
      title: 'Getting Started',
      description: 'Understand Miden and STARK proofs',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 19.5C4 18.1193 5.11929 17 6.5 17H20V21C20 21.5523 19.5523 22 19 22H6.5C5.11929 22 4 20.8807 4 19.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6.5 2C5.11929 2 4 3.11929 4 4.5V17.2547C4.5 16.8875 5.07312 16.6458 5.68957 16.5596L6.5 16.5H20V4C20 3.44772 19.5523 3 19 3H6.5C5.11929 3 4 2.11071 4 4.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 7H16V9H8V7Z" fill="currentColor"/>
          <path d="M8 11H14V13H8V11Z" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 'first-programs',
      title: 'First Programs',
      description: 'Write and run your first Miden program with step-by-step guidance and examples.',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M8.5 6.5L4 12L8.5 17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15.5 6.5L20 12L15.5 17.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  return (
    <section className="getting-started">
      <div className="getting-started-cards-strip">
        {items.map((item) => (
          <div
            key={item.id}
            className="getting-started-card"
          >
            <div className="getting-started-icon">{item.icon}</div>
            <div className="getting-started-content">
              <h3 className="getting-started-title">{item.title}</h3>
              <p className="getting-started-description">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GettingStarted;